import { useDispatch } from 'react-redux';

import { updateCartItem } from 'redux/cart/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

const QuantitySelect = (props) => {
  const { item, onSetFieldType, onIsQuantityUpdating } = props;

  const dispatch = useDispatch();
  const { t } = useLocalization();

  const handleOnSelect = (e) => {
    const { value } = e.target;
    if (value === 'Other') {
      onSetFieldType('Input');
    } else {
      const quantity = parseInt(value, 10);
      let useLoyaltyPoints = false;
      if (item.itemData?.useLoyaltyPoints) {
        useLoyaltyPoints = true;
      }
      onIsQuantityUpdating(true);
      const onSuccess = () => {
        onIsQuantityUpdating(false);
      };
      const onError = () => {
        onIsQuantityUpdating(false);
      };

      dispatch(
        updateCartItem(item.id, quantity, useLoyaltyPoints, onSuccess, onError)
      );
    }
  };

  const countArray = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12'
  ];
  const id = `c7-quantity-${item.id}`;
  const labelId = `${id}-label`;
  return (
    <div className="c7-order-item__quantity">
      {}
      <label htmlFor={id} id={labelId} className="c7-sr-only">
        {t('products.general.quantity')}
      </label>
      <select
        name="c7-quantityOther"
        id={id}
        onChange={handleOnSelect}
        value={item.quantity.toString()}
        aria-labelledby={labelId}
      >
        {countArray.map((i) => (
          <option value={i} key={i}>
            {i}
          </option>
        ))}
        <option value="Other">{t('general.common.other')}</option>
      </select>
    </div>
  );
};

export default QuantitySelect;
